
<section class="mobile-navigation-bg"
         (click)="closeMobileView()"
         [style.display]="openMenu && isMobileView ? 'block' : 'none'">

</section>

<section class="navigation"
         [class.active]="openMenu"
         [class.mobile]="isMobileView">
  <div class="navigation-actions">
    <app-button-icon iconName="devices_other"
                     [label]="'common.navigation.deviceProfiles' | translateSafe"
                     class="labeled"
                     [routerLink]="['/settings']"
                     routerLinkActive="active"
                     (click)="closeMobileView()"
                     [routerLinkActiveOptions]="{exact: true}"/>

    <app-button-icon iconName="warning"
                     [label]="'common.navigation.alarm-rule.title' | translateSafe"
                     class="labeled"
                     [routerLink]="['/settings/alarm-rules']"
                     (click)="closeMobileView()"
                     routerLinkActive="active" />

    <app-button-icon iconName="notifications"
                     [label]="'common.navigation.notifications' | translateSafe"
                     class="labeled"
                     [routerLink]="['/settings/notifications']"
                     (click)="closeMobileView()"
                     routerLinkActive="active" />

    <app-button-icon iconName="groups"
                     [label]="'common.title.user' | translateSafe"
                     class="labeled"
                     [routerLink]="['/settings/users']"
                     (click)="closeMobileView()"
                     routerLinkActive="active" />

    <app-button-icon iconName="docs"
                     label="Audit-Logs"
                     class="labeled"
                     [routerLink]="['/settings/logs']"
                     (click)="closeMobileView()"
                     routerLinkActive="active" />

  </div>
  <button class="toggle-button"
          [style.display]="isMobileView ? 'flex' : 'none'"
          (click)="toggleMobileView()">
    <span class="material-symbols-rounded">
      {{ openMenu ? 'chevron_left' : 'chevron_right' }}
    </span>
  </button>
</section>
